import { Box, makeStyles } from '@material-ui/core';
import { SDropdownMenu, SEmptyState, SButton } from '@setvi/shared/components';
import {
  AddBySKUOutlineIcon,
  AddSPOOutlineIcon,
  FillBagOutlineIcon,
  MoveIcon
} from '@setvi/shared/components/sicons';
import { PlusButtonIcon } from 'pages/sales/modules/intelligence/subpages/intelligence-details/components/dynamic-content/content/pitch-and-review/cross-sell-sub-content/components/selected-rows-control-panel/styled';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px 0px'
  },
  sectionEmptyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '18px'
  },
  buttonsContainer: {
    display: 'flex',
    gap: '12px',
    marginTop: '12px'
  },
  subtitle: {
    color: '#5D7083',
    fontSize: '16px'
  }
}));

interface SectionEmptyStateProps {
  onAddFromCatalog: () => void;
  onAddBySKU: () => void;
  onAddSPO: () => void;
  onMoveExistingItems?: () => void;
  disabled?: boolean;
}

export const SectionEmptyState = ({
  onAddFromCatalog,
  onAddBySKU,
  onAddSPO,
  onMoveExistingItems,
  disabled = false
}: SectionEmptyStateProps) => {
  const classes = useStyles();
  const disabledTooltip = disabled ? 'Quote is not editable' : '';

  const buttons = (
    <Box className={classes.sectionEmptyContainer}>
      <Box className={classes.buttonsContainer}>
        <SDropdownMenu
          newDesign
          menuItems={[
            {
              icon: <FillBagOutlineIcon fontSize="small" />,
              text: 'Add From Catalog',
              color: '#333D47',
              onClick: onAddFromCatalog
            },
            {
              icon: <AddBySKUOutlineIcon fontSize="small" />,
              text: 'Add by SKU',
              color: '#333D47',
              onClick: onAddBySKU
            },
            {
              icon: <AddSPOOutlineIcon fontSize="small" />,
              text: 'Add SPO',
              color: '#333D47',
              onClick: onAddSPO
            }
          ]}>
          <SButton
            tooltipTitle={disabledTooltip}
            startIcon={<PlusButtonIcon />}
            variant="outlined"
            disabled={disabled}>
            Add Items
          </SButton>
        </SDropdownMenu>
        <SButton
          tooltipTitle={disabledTooltip}
          startIcon={<MoveIcon fontSize="small" />}
          variant="outlined"
          onClick={onMoveExistingItems}
          disabled={disabled}>
          Move Existing Items
        </SButton>
      </Box>

      <Box className={classes.subtitle}>
        This Section will appear in the quote preview after adding items.
      </Box>
    </Box>
  );

  return (
    <Box className={classes.container}>
      <SEmptyState
        maxWidth="unset"
        title="No Items Yet"
        additionalContent={buttons}
      />
    </Box>
  );
};
